'use client'

import type { useStore } from 'jotai'
import { useHydrateAtoms } from 'jotai/utils'
import type { WritableAtom } from 'jotai/vanilla'
import type { PropsWithChildren } from 'react'

type AnyWritableAtom = WritableAtom<unknown, never[], unknown>

type InferAtomTuples<T> = {
  [K in keyof T]: T[K] extends readonly [infer A, unknown]
    ? A extends WritableAtom<unknown, infer Args, infer _Result>
      ? readonly [A, Args[0]]
      : T[K]
    : never
}

type Options = Parameters<typeof useStore>[0] & {
  dangerouslyForceHydrate?: boolean
}

interface HydrateAtomsProps<T> {
  initialValues: InferAtomTuples<T>
  options?: Options
}

export const HydrateAtoms = <T extends [AnyWritableAtom, unknown][]>({
  initialValues,
  options,
  children,
}: PropsWithChildren<HydrateAtomsProps<T>>) => {
  // https://jotai.org/docs/utilities/ssr
  // initialising on state with prop on render here
  useHydrateAtoms(initialValues, options)
  return children
}
